import axios from "axios";
import interceptors from "./interceptors.js"; // eslint-disable-line no-unused-vars


// 1. HTTP Request & Response와 관련된 기본 설정
const config = {
  baseUrl: process.env.VUE_APP_PLAN_API_BASE,
};

// 2. API 함수들을 정리
function fetchExamInfo(payload){

  return axios.get(`${config.baseUrl}/study/plan/test`, {
    params: {
      frlProgressCd: payload, 
    },
    withCredentials: true
  });

}

// function fetchRecentExamInfo(){
//   return axios.get(`${config.baseUrl}/db`);  
// }

export {
  fetchExamInfo,
  // fetchRecentExamInfo,
};
